// extracted by mini-css-extract-plugin
export default {"fade-in-up":"fade-in-up","fadeInUp":"fadeInUp"};